import * as React from 'react';
import FormControl from '@material-ui/core/FormControl/FormControl';
import {ExtendedWrappedFieldProps, FormField} from '../FormFields';
import Button from '@material-ui/core/Button';
import {Theme, createStyles} from '@material-ui/core/styles';
import withStyles, {WithStyles} from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography/Typography';
import withEllipsis from '@material-ui/core/utils/withEllipsis';

const TypographyWithEllipsis = withEllipsis()(Typography);
const styles = (theme: Theme) =>
  createStyles({
    formControl: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    button: {
      flexShrink: 0,
    },
    fileName: {
      marginLeft: theme.spacing(2),
    },
  });

const FormFile: React.SFC<ExtendedWrappedFieldProps & WithStyles<typeof styles>> = ({
  classes: {fileName, formControl, button},
  instructionText,
  explanationText,
  label,
  instructionPosition,
  showErrors,
  meta: {error, touched},
  input: {onChange, value, name},
}) => {
  return (
    <FormField
      error={error}
      touched={touched}
      showErrors={showErrors}
      explanationText={explanationText}
      instructionText={instructionText}
      instructionPosition={instructionPosition}
      fieldName={name}
    >
      <FormControl className={formControl}>
        <Button variant="contained" component="label" className={button}>
          {label}
          <input
            style={{display: 'none'}}
            type="file"
            onChange={event => onChange(event.target.files[0])}
            accept=".csv,.txt"
          />
        </Button>
        <TypographyWithEllipsis className={fileName}>{value.name}</TypographyWithEllipsis>
      </FormControl>
    </FormField>
  );
};

export default withStyles(styles, {name: 'FormFile'})(FormFile);
